var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProccessing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.05 24.96h8.807a3.057 3.057 0 0 1 3.048 3.048v15.97c0 10.88-7.589 16.974-16.976 16.974H17.975C8.59 60.952 1 54.857 1 43.977V16.975C1 6.095 8.589 0 17.975 0h12.922a3.057 3.057 0 0 1 3.048 3.048v8.807c0 7.223 5.882 13.105 13.105 13.105zM38.12 1.98c0-1.736 2.163-2.59 3.413-1.34 3.045 3.046 7.619 7.661 11.62 11.698 1.924 1.942 3.716 3.75 5.141 5.186 1.22 1.219.305 3.26-1.432 3.26-3.444 0-7.467 0-10.362-.03-4.602 0-8.38-3.687-8.38-8.137V1.981z",
    fill: "url(#ypd8mpz7xa)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.362 52.602c-7.162.518-7.162 10.88 0 11.398h16.944c2.042 0 4.054-.762 5.547-2.133 5.029-4.389 2.347-13.166-4.267-13.989-2.377-14.293-23.04-8.868-18.163 4.754",
    fill: "url(#3junt4exab)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ypd8mpz7xa",
    x1: 1,
    y1: 0,
    x2: 1,
    y2: 60.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3junt4exab",
    x1: 32.99,
    y1: 39.447,
    x2: 32.99,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProccessing);
export default __webpack_public_path__ + "static/media/proccessing.701db33cdf1a21d0efa6e8101cf90b02.svg";
export { ForwardRef as ReactComponent };